import type { FC } from 'react';

interface Props {
  className?: string;
}

const BikeStorageIcon: FC<Props> = ({ className = 'w-5 h-5 mr-1' }) => {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <circle cx="6" cy="18" r="3" strokeWidth="2" />
      <circle cx="18" cy="18" r="3" strokeWidth="2" />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M9 18h6M12 8l-3 10m6-10l-3 10M12 8V5l2-2"
      />
      <circle cx="12" cy="5" r="1" fill="currentColor" />
    </svg>
  );
};

export default BikeStorageIcon;
